// Refresh the token if it expires within this window. Access tokens live for
// 300s, and a margin of a few seconds is narrower than normal request latency,
// so a token that passes the check can still expire in flight and be rejected
// by the backend as JWTExpired.
export const MIN_SECONDS_BEFORE_REFRESH_KEYCLOAK_TOKEN = 30;
